import { useEffect } from "react";
import ChatStateHandler from "src/StateHandlers/ChatStateHandler";

function InitiateWebSocket() {

  useEffect(() => {
    // console.log('ChatStateHandler')
    ChatStateHandler.connect();

    return ChatStateHandler.removeListener();
  }, [])

  return <></>
}
export default InitiateWebSocket